"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('inlinePreviewOption', {
    isEnabled: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inline-previews-option/lib/store/store.js
// module id = 3070
// module chunks = 2